<template>
  <layout-admin-dashboard-view
    :show-toolbar="false"
    :back-route="{ name: 'admin' }">
    <template #title>
      <span>{{ translateTitleCase("chat.admin.message.listPageTitle") }}</span>
    </template>

    <template #default>
      <custom-crud-list v-bind="listConfiguration">
        <template #cell-createdAt="{ item }">
          <div
            class="cursor-pointer text-overflow-ellipsis max-width-200"
            style="
              display: inline-block;
              direction: ltr;
              unicode-bidi: bidi-override;
              text-align: start;
            ">
            <span>{{ translateDate(item?.createdAt, "dateWithTime") }}</span>
          </div>
        </template>
        <template #cell-content="{ item }">
          <div
            v-tooltip="{ content: item.content, translate: false }"
            class="cursor-pointer text-overflow-ellipsis max-width-200">
            <span>{{ `${item?.content}` }}</span>
          </div>
        </template>
        <template #cell-SenderId="{ item }">
          <div
            v-tooltip="{
              content: `${item?.Sender?.fullName} (${item?.Sender?.email})`,
              translate: false,
            }"
            class="cursor-pointer text-overflow-ellipsis max-width-200">
            <span>{{
              `${item?.Sender?.fullName} (${item?.Sender?.email})`
            }}</span>
          </div>
        </template>
        <template #cell-Recipients="{ item }">
          <div
            v-tooltip="{
              content: getRecipientsString(item),
              translate: false,
            }"
            class="cursor-pointer text-overflow-ellipsis max-width-200">
            <span>{{ getRecipientsString(item) }}</span>
          </div>
        </template>
        <template #cell-state="{ item }">
          <span v-if="item?.state" class="c-success">
            <icon icon="check"></icon>
          </span>
          <span v-else class="c-error">
            <icon icon="x"></icon>
          </span>
        </template>
        <template #cell-initiallyFlagged="{ item }">
          <span v-if="item?.initiallyFlagged" class="c-success">
            <icon icon="check"></icon>
          </span>
          <span v-else class="c-error">
            <icon icon="x"></icon>
          </span>
        </template>
      </custom-crud-list>

      <modal
        :show-footer="false"
        size="l"
        :show="!!currentConversationUuid"
        @modal:closed="currentConversationUuid = false">
        <chat
          v-if="currentConversationUuid"
          style="height: 60vh"
          :show-send-controls="false"
          :show-header="true"
          :conversation-uuid="currentConversationUuid"></chat>
      </modal>
    </template>
  </layout-admin-dashboard-view>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations";
import CustomCrudList from "@/client/components/crud/customV1/List.vue";
import Chat from "@/client/components/chat/Chat.vue";

export default {
  components: { CustomCrudList, Chat },
  layout: "adminDashboard",

  middleware: {
    requireSuperAdmin: {},
  },
  props: {},
  setup(props) {
    let { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props);
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  meta: "chat.admin.message.listPageMetaTitle",
  data: function () {
    return {
      currentConversationUuid: null,
      listConfiguration: {
        subject: "chatMessage",
        listSrc: "entity/chatMessage",
        showIdField: true, // bool deafult true
        sortable: false, //bool, default false
        publishable: true, //bool, default false
        enableMassActions: true,
        editRoutePrefix: "admin-",
        createRoutePrefix: "admin-",
        deleteRoutePrefix: "entity/",
        additionalListData: {
          simplified: false,
          translate: false,
        },
        fields: {
          // these are the table columns
          createdFrom: {
            itemKey: "createdFrom",
            label: "chat.admin.message.fields.createdFrom",
            listable: false,
            filterable: {
              name: "createdFrom",
              type: "datePicker",
              placeholder: "chat.admin.message.fields.createdFrom",
            }, //
            orderable: true,
          },
          createdUntil: {
            itemKey: "createdUntil",
            label: "chat.admin.message.fields.createdUntil",
            listable: false,
            filterable: {
              name: "createdUntil",
              type: "datePicker",
              placeholder: "chat.admin.message.fields.createdUntil",
            }, //
            orderable: true,
          },
          content: {
            itemKey: "content",
            label: "chat.admin.message.fields.content",
            filterable: true, // boolean, or object
            orderable: true,
          },
          SenderId: {
            itemKey: "SenderId",
            label: "chat.admin.message.fields.sender",
            filterable: {
              name: "SenderId",
              type: "Select2",
              translateList: false,
              valueKey: "id",
              labelKey: "name",
              placeholder: "chat.admin.message.fields.sender",
              itemComponent: "iconItem",
              asyncListSource: "entity/User",
              asyncListLive: false,
              textFilterAsSaffronListFilter: true,
              asyncDataTextFilterParamName: "fullName",
              multiple: false,
              asyncListData: {
                simplified: true,
              },
            }, // boolean, or object
          },
          Recipients: {
            name: "Recipients",
            itemKey: "Recipients",
            label: "chat.admin.message.fields.recipients",
            filterable: {
              name: "Recipients",
              type: "Select2",
              translateList: false,
              valueKey: "id",
              labelKey: "name",
              placeholder: "chat.admin.message.fields.recipients",
              itemComponent: "iconItem",
              asyncListSource: "entity/User",
              asyncListLive: false,
              textFilterAsSaffronListFilter: true,
              asyncDataTextFilterParamName: "fullName",
              multiple: false,
              asyncListData: {
                simplified: true,
              },
            }, // boolean, or object
          },
          /*
           BrandId: {
           itemKey: "BrandId",
           label: "ecommerce.product.fields.brand",
           filterable: {
           name: "BrandId",
           type: "Select2",
           translateList: false,
           valueKey: "id",
           labelKey: "name",
           placeholder: "ecommerce.product.fields.brandFilterPlaceholder",
           itemComponent: "iconItem",
           asyncListSource: "entity/Brand",
           asyncListLive: false,
           textFilterAsSaffronListFilter: true,
           asyncDataTextFilterParamName: "name",
           multiple: false,
           asyncListData: {
           simplified: true,
           },
           }, // boolean, or object
           },
           introImage: {
           itemKey: "introImage",
           label: "ecommerce.product.fields.introImage",
           },
           */
          state: {
            itemKey: "state",
            label: "chat.admin.message.fields.state",
            filterable: {
              name: "state",
              type: "select2",
              placeholder: "chat.admin.message.fields.state",
              translateList: true,
              list: [
                { value: 0, label: "core.entity.stateValues.0" },
                { value: 1, label: "core.entity.stateValues.1" },
              ],
            }, // boolean, or object
            orderable: true,
            quickEdit: {
              type: "binaryInteger",
            },
          },
          initiallyFlagged: {
            itemKey: "initiallyFlagged",
            label: "chat.admin.message.fields.initiallyFlagged",
            filterable: {
              name: "initiallyFlagged",
              type: "select",
              placeholder: "chat.admin.message.fields.initiallyFlagged",
              translateList: true,
              list: [
                { value: undefined, label: "core.any" },
                { value: false, label: "core.no" },
                { value: true, label: "core.yes" },
              ],
            }, // boolean, or object
            orderable: true,
            quickEdit: {
              type: "binary",
            },
          },
        },
        actions: {
          show: false,
          edit: true,
          delete: true,
          create: false,
          custom: {
            showChat: {
              //tooltip
              tooltip: { content: "chat.admin.message.showChatTooltip" },
              icon: "eye",
              theme: "inverse",
              //text
              handler: async ({ item }) => {
                this.currentConversationUuid = item.Conversation.uuid;
                console.log("show chat");
                console.log(item);
              },
            },
          },
        },
      },
      asyncData: {},
    };
  },
  computed: {},
  methods: {
    getRecipientsString(item) {
      let users = item.Recipients || [];
      let res = users.map((user) => `${user.fullName} (${user.email})`);
      return res.join(", ");
    },
  },
};
</script>
